import React from 'react';
import map from 'lodash/map';

import { SelectOption } from '../Rule/helpers/memoriesHelper';
import Dropdown from 'src/presentation/components/forms/Dropdown';
import { HalfRow } from './Layout';

const BoolControl = ({ attr }: { attr: string }) => {
  const opts: SelectOption[] = map(
    ['true', 'false'],
    (v: string): SelectOption => ({
      label: v,
      value: v,
    })
  );

  return (
    <HalfRow>
      <Dropdown attr={attr} options={opts} />
    </HalfRow>
  );
};

export default BoolControl;
